module.exports = __webpack_public_path__ + "img/layout.cfcdf280.svg";